import { render, staticRenderFns } from "./SegmentedTabs.vue?vue&type=template&id=76ac7e9d&scoped=true"
import script from "./SegmentedTabs.vue?vue&type=script&lang=js"
export * from "./SegmentedTabs.vue?vue&type=script&lang=js"
import style0 from "./SegmentedTabs.vue?vue&type=style&index=0&id=76ac7e9d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ac7e9d",
  null
  
)

export default component.exports